import type {
  UserTradingAnalyticsDto,
  UserTradingAnalyticsPhishingSeverityDto,
} from '@root/shared/api/TradeApi'

export enum UserTradingAnalyticsPhishingSeverity {
  Normal = 'Normal::UserTradingAnalyticsPhishingSeverity',
  Warning = 'Warning::UserTradingAnalyticsPhishingSeverity',
  Danger = 'Danger::UserTradingAnalyticsPhishingSeverity',
}

export enum UserTradingAnalyticsPhishingPoint {
  Blacklist = 'Blacklist::UserTradingAnalyticsPhishingPoint',
  DidntBuy = 'DidntBuy::UserTradingAnalyticsPhishingPoint',
  SoldMoreThanBought = 'SoldMoreThanBought::UserTradingAnalyticsPhishingPoint',
  FastFlip = 'FastFlip::UserTradingAnalyticsPhishingPoint',
}

export interface UserTradingAnalyticsPhishingValue {
  count: number
  percent: number
  severity: UserTradingAnalyticsPhishingSeverity
}

export interface UserTradingAnalyticsPhishing
  extends Record<
    UserTradingAnalyticsPhishingPoint,
    UserTradingAnalyticsPhishingValue
  > {}

const SEVERITY_MAP: Record<
  UserTradingAnalyticsPhishingSeverityDto,
  UserTradingAnalyticsPhishingSeverity
> = {
  normal: UserTradingAnalyticsPhishingSeverity.Normal,
  warning: UserTradingAnalyticsPhishingSeverity.Warning,
  danger: UserTradingAnalyticsPhishingSeverity.Danger,
}

export const fromDto = (
  dto: UserTradingAnalyticsDto['phishing'],
): UserTradingAnalyticsPhishing => {
  return {
    [UserTradingAnalyticsPhishingPoint.Blacklist]: {
      count: dto.blacklist.count,
      percent: dto.blacklist.percent,
      severity: SEVERITY_MAP[dto.blacklist.severity],
    },
    [UserTradingAnalyticsPhishingPoint.DidntBuy]: {
      count: dto.didntBuy.count,
      percent: dto.didntBuy.percent,
      severity: SEVERITY_MAP[dto.didntBuy.severity],
    },
    [UserTradingAnalyticsPhishingPoint.SoldMoreThanBought]: {
      count: dto.soldMoreThanBought.count,
      percent: dto.soldMoreThanBought.percent,
      severity: SEVERITY_MAP[dto.soldMoreThanBought.severity],
    },
    [UserTradingAnalyticsPhishingPoint.FastFlip]: {
      count: dto.fastFlip.count,
      percent: dto.fastFlip.percent,
      severity: SEVERITY_MAP[dto.fastFlip.severity],
    },
  }
}
